/**
 * Referee pattern assignment for imported requests.
 *
 * Priority:
 *  1. Game type — State League / National 1 / Intraclub games get no
 *     referees regardless of field size.
 *  2. Field size — the most reliable crew-size signal: 7v7 and smaller are
 *     solo-ref games, 9v9 and 11v11 take a full Diagonal (3) crew. Matters
 *     for multi-slot submissions, where one age group can span slots of
 *     different sizes.
 *  3. Age group fallback — when the field size is missing or unrecognized,
 *     Friendly games at U8–U10 are solo-ref.
 *
 * Mirrored in scripts/import_league_schedule.py (determine_referee_pattern) —
 * keep the two in sync.
 */
export const determineRefereePattern = (gameType, ageGroup, fieldSize) => {
  const type = (gameType || '').toLowerCase().trim();

  if (type.includes('state league') || type.includes('national 1') || type.includes('intraclub')) {
    return 'No Refs';
  }

  const size = (fieldSize || '').toLowerCase().trim();
  if (size === '7v7' || size === 'small sided') return 'Solo';
  if (size === '9v9' || size === '11v11') return 'Diagonal (3)';

  if (type.includes('friendly')) {
    const age = (ageGroup || '').toUpperCase().trim();
    if (age === 'U8' || age === 'U9' || age === 'U10') return 'Solo';
  }

  return 'Diagonal (3)';
};
